// 创建文件en/index.js
const Jap = {
    my: "私の",
    today: "今日",
    this_week: "今週",
    this_month: "今月",
    last_month: "先月",
    this_year: "今年",
    number_of_people: "人数",
    amount: "金額",
    enter_username_id_to_search: "ユーザー名IDを入力して検索",
    team_list: "チームリスト",
    registration_time: "登録日時",
    selling_face_value: "売却額面",
    click_for_details: "詳細をクリック",
    "agent_login": "エージェントログイン",
    "Agent.Center": "エージェントセンター",
    'SignOut': 'アカウントをログアウト',
    'Contact us': "お問い合わせ",
    'Download our app': "アプリをダウンロード",
    'Download it from': "ダウンロードURL",
    'About Us': "私たちについて",
    'Gobuy USA was founded in 2012': "Gobuy USA は 2012 年に設立されました",
    'Customer service': "顧客サービス",
    'frequently asked question': "常见问题",
    'Return and exchange policy': "返品および交換ポリシー",
    'Shipping and distribution': "配布・配送",
    'Contact us by email': "電子メールでお問い合わせください",
    'Privacy Policy and Terms of Use': "プライバシーポリシーと利用規約",
    'Privacy Policy': "プライバシーポリシー",
    'Terms of use': "利用規約",
    'Upload credentials': "認証情報のアップロード",
    'The withdrawal is being processed': "出金中です",
    'Cause of failure': "失敗の理由",
    'Your shopping cart is still empty': "ショッピングカートはまだ空です",
    'Log in to view the items in your cart': "ログインしてショッピング カート内の商品を表示します",
    'Browse around': "ブラウズ",
    'Account correlation': "アカウント関連",
    'Order management': "注文管理",
    'Payment method': "支払方法",
    'Collection address': "支払い先住所",
    Category: "分類",
    "MyCommission": "私の任務",
    "Gross income": "総収益",
    "Direct commission": "直接手数料",
    "Indirect commission": "間接手数料",
    "Transfer to wallet": "ウォレットに転送する",
    "Tip: The transfer amount must be greater than 10USDT": "ヒント: 送金金額は 10USDT より大きくなければなりません",
    "transfer": "移行",
    "commission": "手数料",
    "Please enter": "入力してください",
    "Team Commission": "チームコミッション",

    'Old Password': "以前のパスワード",
    'Change password': "パスワードを変更する",
    'Gobuy GIFT CARD': "ゴーバイギフトカード",
    'High Priced Recycling': "高価リサイクル",
    'Data': "日付",
    'congratulations': "おめでとう",
    'Obtain': "得る",
    'ThankYouForParticipating': "ご参加いただきありがとうございました",

    // navbar"",
    Home: "フロントページ",
    Search: "検索",
    ShoppingCart: "ショッピングカート",
    Mine: "私の",

    // 首页
    // 搜索
    EnterSearchContent: "検索内容を入力してください",
    'Recent searches': "最近の検索",
    'popular searches': "人気の検索",
    'Please search': "検索したいキーワードを入力してください",
    'orderSearch': "注文名または製品名を入力して検索します",

    // 语言
    'Language selection': "言語の選択",

    // menu
    Brand: "ブランド",
    Collect: "集める",
    Manage: "管理",
    Order: "注文",
    Wallet: "財布",
    BlindBox: "ブラインドボックス",
    MenuGiftCard: "ギフトカード",
    // HotSale
    HotSale: "最新ニュースが発売中です...",
    // tabs"",
    TodaysOffer: "プラットフォーム推奨",
    'Phone': "携帯電話",
    'Smart Watch': "スマートウォッチ",
    'Smart bracelet': "スマートブレスレット",

    // gobuy
    'home.gobuy.title': "驚きがあなたを待っています",
    'home.gobuy.periods': "ブラインドボックス ラウンド",
    'home.gobuy.freeze': "カウントダウンに参加する",
    'home.gobuy.drawing': "カウントダウン開始",
    'home.gobuy.buy': "参加する",
    'home.gobuy.isbuy': "すでに参加しています",
    
    'home.gobuy.jackpot': "賞金総額",
    Purse: "財布",
    Box: "ブラインドボックス",
    'GetAPrize': "賞品を獲得する",
    Discount: "割引",
    when: "いつ",
    points: "積分",
    seconds: "2番",
    // MessageBox
    'MessageBox.Tips': "ヒント",
    'MessageBox.Confirm': "確認する",
    'MessageBox.Cancel': "キャンセル",
    'MessageBox.buy.box': "このブラインドボックスを購入してもよろしいですか?",
    // Toast
    'succ': "成功",
    'err': "間違い",
    'box.succeeds': "購入が成功しました",
    'box.frozen': "すでに参加しています",
    'box.issue': "ブラインドボックスは1号につき1枚のみ購入可能です",

    // 商品列表
    filter: "フィルター",
    sales: "販売数量",
    selfOP: "自走式",
    noMore: "もうない",
    brand: "ブランド",
    confirm: "確認する",
    reset: "リセット",
    ComSor: "総合仕分け",
    MostPop: "最も人気のある",
    HighLow: "価格が高いものから安いものまで",
    LowHigh: "価格が安いものから高いものまで",
    SalVol: "販売量",
    NewArr: "新着",

    // 购物车
    'cart.cart': "ショッピングカート",
    'cart.edit': "編集",
    'cart.done': "仕上げる",
    'home.cart.voucher': "クーポンを入手する",
    'home.cart.outstock': "在庫切れ",
    'home.cart.offshelf': "棚から削除されました",
    'Only': "のみ",
    'left': "個人的な",
    'Promotion': "プロモーション",
    'cart.all': "すべて選択",
    'cart.total': "合計",
    'cart.delete': "消去",
    'cart.checkout': "お勘定お願いします",

    // 我的
    'Direct': "直接",
    'Indirect': "間接的な",
    'MyOrders': "私の注文",
    'ViewAll': "すべて見る",
    'Unpaid': "支払い保留中",
    'ToShip': "出荷待ち",
    'ToReceive': "受け取り待ち",
    'ToReview': "評価待ち",
    // 盲盒
    'MyBlindBox': "ブラインドボックス一覧",
    'WaitingDraw': "抽選を待っています",
    'Opened': "開封済み（受け取り/返品）",
    // 礼品卡
    'After sale': "アフターセールス",
    'GiftCard': "リサイクル記録",
    'RecycleGiftCard': "ギフトカードをリサイクルする",
    'Verifying': "チェック",
    'Rebuying': "再購入",
    'Repurchased': "支払い待ち",
    'Paid': "支払いが完了しました",
    // 常用工具
    'CommonTools': "共通ツール",
    'MyWallet': "私の財布",
    'VirtualOrders': "仮想秩序",
    'Refunds': "返金",
    'MyFriends': "私の友人",
    'ChatList': "チャットリスト",
    'RealNameVerification': "実名認証",
    'MyFavorites': "私のコレクション",
    'Addresses': "アドレス管理",
    'MyReviews': "私のレビュー",
    'BrowsingHistory': "閲覧履歴",
    'Promotions': "プロモーション",
    'StoreManagement': "店舗管理",
    'BecomeASeller': "販売者になる",

    // 订单列表
    'SearchPlaceholder': "注文商品名を入力して検索します",
    All: "全て",
    OrderNo: "注文番号",
    items: "個",
    ShippingFee: "貨物",
    'Refund in Progress': "返金中です",
    'Cancel Order': "注文をキャンセルする",
    'Refund': "返金",
    'Track Shipping': "物流をチェックする",
    'Confirm Receipt': "商品の受領を確認する",
    'Evaluate': "評価する",
    'Delete': "消去",
    'Pay': "支払い",
    'MessageBox.delete.order': "この注文を削除してもよろしいですか?",
    'MessageBox.cancel.order': "この注文をキャンセルしてもよろしいですか?",
    'MessageBox.receive.order': "この注文は受領されましたか?",
    // 订单详情
    'Order Details': "注文の詳細",
    'Pickup Code': "ピックアップコード",
    'Complaint': "苦情",
    'After-Sales': "アフターセールス",
    'Gift': "贈り物",
    'Order Date': "注文日",
    'Used voucher worth': "バウチャーの使用金額",
    'CNY': "人民元",
    'Payment Method': "支払方法",
    'Total Product Amount': "商品合計金額",
    'Shipping Fee': "貨物",
    'Amount Paid': "支払った金額",
    'Return': "商品を返品する",
    // 盲盒列表
    'Pending Draw': "宝くじの抽選待ち",
    'Pending Unboxing': "オープン予定",
    'Unboxed': "すでにオンになっています",
    'Collected': "受け取った",
    'Recycled': "リサイクル",
    'Unknown': "未知",
    'Claim': "受け取る",
    'Recycle': "自社株買い ",
    'Unbox': "オンにする",
    'MessageBox.recycle.box': "このブラインドボックスをリサイクルしてもよろしいですか?",
    // 盲盒详情
    'Mystery Box Details': "ブラインドボックス詳細",
    'Unopened': "電源が入っていない",
    'box.opened': "電源が入っていない",
    'Claimed': "受け取った",
    'Confirm Claim': "回収の確認",
    'MessageBox.pick.box': "このブラインド ボックスを抽出してもよろしいですか?",
    // 盲盒提货
    'Please add address': "住所を追加してください",
    // 礼品卡列表
    'Face Value Total': "額面総額",
    // 礼品卡详情
    'Gift Card Details': "ギフトカードの詳細",
    'Card number': "カード番号",
    'Activation code': "アクティベーションコード",
    'Actual recovery price': "実際のリサイクル価格",
    // 礼品卡回收
    'Gift Card Recycling': "ギフトカードのリサイクル",
    'Confirm Recycling': "リサイクルの確認",
    'Please enter the card number': "カード番号を入力してください",
    'Please enter the activation code': "アクティベーション コードを入力してください",
    'MessageBox.recycle.gift': "このギフトカードをリサイクルしてもよろしいですか?",

    // 我的钱包
    'My Wallet': "私の財布",
    'Available Balance': "利用可能残高",
    'Gift Balance': "ギフト残高",
    'All': "すべて",
    'Next event loading': "次のイベントを読み込んでいます",
    'Frozen Funds': "資金を凍結する",
    'Recharge': "補充する",
    "can": "可",
    'Withdraw': "現金を引き出す",
    'Withdrawal Accounts': "引き出し口座",
    // 充值
    'Recharge Details': "リチャージの詳細",
    'Recharge Order No.': "リチャージ注文番号",
    'Recharge Amount': "チャージ金額",
    'Creation Time': "作成時間",
    'MessageBox.recharge.pop': "チャージ金額を入力してください",
    // 付款
    'payment': "支払い",
    'Order submitted successfully, please select payment method': "注文は正常に送信されました。支払い方法を選択してください",
    'Rechargeable card': "リチャージ可能なカード",
    'Please enter a hash': "ハッシュを入力してください",
    'Immediate payment': "今すぐお支払いください",
    'Wait for the file to load': "ファイルがロードされるまでお待ちください",
    // 提现
    'Withdrawal Details': "出金詳細",
    'Withdrawal Amount': "出金額",
    'Application Time': "申請時間",
    'New Application': "新しいアプリケーション",
    'Payment Password': "支払いパスワード",
    'New Payment Password': "新しい支払いパスワード",
    'Recipient Information': "受取人情報",
    'Submit': "提出する",
    'Add Recipient Account First': "まず支払いアカウントを追加してください",
    'Please bind your mobile phone or email first': "まず携帯電話または電子メールをバインドしてください",
    // 设置
    'Account Settings': "アカウント設定",
    'Change Login Password': "ログインパスワードを変更する",
    'Change Payment Password': "支払いパスワードを変更する",
    'Log Out': "サインアウト",
    'Mobile': "携帯電話",
    'Verification Code': "検証コード",
    'Email': "郵便",
    'New Password': "新しいパスワード",
    'Confirm Password': "パスワードを認証する",
    'Modify': "改訂",
    'Bind': "バインディング",
    ' Mobile': "携帯電話",
    ' Email': "郵便",
    // 资金详情
    'Fund Details': "資金調達の詳細",
    'Withdrawal Account': "引き出し口座",
    'Account Type': "アカウントの種類",
    'USDT Address (opBNB)': "USDT-opBNB",
    'Edit': "編集",
    'Delete': "消去",
    'Add New': "新しいアカウントを追加",
    'MessageBox.delete.bank': "この引き出し口座を削除してもよろしいですか?",
    // 登录
    'Login': "ログイン",
    'Sign Up': "登録する",
    'Normal Login': "通常ログイン",
    'Username / Email / Phone Number': "ユーザー名/メールアドレス",
    'Enter Phone Number': "携帯電話番号を入力してください",
    'Enter Email': "メールアドレスを入力してください",
    'Enter SMS Code': "SMS認証コードを入力してください",
    'Enter Password': "パスワードを入力してください",
    "enter_login_password_for_verification": "ログインパスワードを入力して認証してください",
    'Forgot Password': "パスワードを忘れる",
    'Third-party Login': "サードパーティのログイン",
    'Please complete the form': "フォームに記入してください",
    'WeChat': "微信",
    'Weibo': "微博",
    'QQ': "QQ",
    'phone login': "モバイルログイン",
    'Login Expired': "ログイン期限が切れました",
    'Please enter your phone number first': "最初に携帯電話番号を入力してください",
    'Please enter your username/email/phone number': "ユーザー名/メールアドレスを入力してください",
    'Please enter your password': "パスワードを入力してください",
    'Password must be at least 6 characters': "パスワードは6文字以上である必要があります",
    'Please enter an 11-digit phone number': "11桁の携帯電話番号を入力してください",
    'Please wait for the file to finish loading': "ファイルがロードされるまでお待ちください",
    'send': "送信",
    'signUpTips': "あなたの個人データは、ウェブサイト全体でのエクスペリエンスのサポート、アカウントへのアクセスの管理、および当社のプライバシー ポリシーに記載されているその他の目的に使用されます。",

    // 注册
    'Sign Up': "登録する",
    'Referrer': "推薦者",
    'Invitation code': "招待コード",
    'Please.enter.Invitation.code': '招待コードを入力してください',
    'Email.verification.code': 'メール確認コード',
    'Invite friends': "友達を招待する",
    'Username': "ユーザー名",
    'Full Name': "本名",
    'Set Password': "パスワードを設定する",
    'Confirm Password': "パスワードを認証する",
    'Phone Number': "電話番号",
    'Email': "電子メール",
    'Username: 3-25 chars, letters & numbers': "ユーザー名: 3 ～ 25 文字の文字と数字",
    '6-20 digits/letters/symbols': "6～20の数字/文字/記号",
    'By clicking sign up, you agree to': "クリックして登録すると、同意したものとみなされます",
    'User Agreement': "ユーザー同意書",
    'Please check the user agreement': "利用規約をご確認ください",
    'Please enter a username with 3-25 characters': "3 ～ 25 文字のユーザー名を入力してください",
    'Enter SMS Verification Code': "SMS認証コードを入力してください",
    'Please enter your phone number': "携帯電話番号を入力してください",
    'Please enter the verification code': "確認コードを入力してください",
    'Please enter a 6-digit verification code': "6桁の認証コードを入力してください",
    'Please enter a password with 6-20 characters': "6～20文字のパスワードを入力してください",
    'Please enter the confirm password': "確認用のパスワードを入力してください",
    'The confirm password does not match the entered password': "確認パスワードが入力されたパスワードと一致しません",

    // 密码恢复
    'Password Recovery': "パスワードの回復",
    'Forgot Password': "パスワードを忘れる",
    'Forget.email.tips': "アカウントがまだ電子メール番号に関連付けられていない場合は、プラットフォーム管理者に連絡してパスワードを回復してください。",

    // 通知
    'Notification Message': "通知メッセージ",
    'Direct Message': "プライベートメッセージ",
    'System Message': "システムメッセージ",
    'Leave a Message': "メッセージ",

    // 配送地址
    'Delivery Address': "お届け先の住所",
    'The store is no longer valid, please edit the delivery address again': "このストアは無効になりました。配送先住所を再編集してください",
    'Default address': "デフォルトアドレス",
    'Add address': "アドレスを追加",
    'Edit address': "住所を編集する",
    'MessageBox.delete.address': "このアドレスを削除してもよろしいですか?",
    'name': "名前",
    'phone': "電話番号",
    'district': "地区",
    'address': "住所",
    'default address': "デフォルトアドレス",
    'save and use': "保存して使用する",
    'save': "保存",
    'Please select a region': "地域を選択してください",
    'Please fill in the recipient name': "受信者名を入力してください",
    'Name must be 2-15 characters': "名前は 2 ～ 15 文字にする必要があります",
    'Please fill in the mobile phone number': "携帯電話番号を入力してください",
    'Please select your location': "所在地を選択してください",
    'Please fill in the detailed address': "詳しい住所をご記入ください",

    // 浏览历史
    'Browsing History': "閲覧履歴",
    'Clear browsing history': "閲覧履歴をクリアする",

    // 推广会员
    'Promotion member': "メンバーを昇格させる",
    "PromotionPoster": "プロモーションポスター",
    "MemberName": "メンバー名",
    "MyAssets": "私の資産",
    "DistributedAmount": "分配金",
    "NumberOfDistributedProducts": "製品数量の割り当て",
    "DistributedProductAmount": "分配金",
    "MyTeam": "私のチーム",
    "LevelOneMembers": "ファーストクラスメンバー",
    "LevelTwoMembers": "第二レベルのメンバー",
    "PromotionPoster": "プロモーションポスター",
    "PromotionMembers": "メンバーを昇格させる",
    "PromotionPerformance": "プロモーションパフォーマンス",
    "ViewPromotionLink": "クリックしてプロモーションリンクを表示",
    "PromoteViaWeChatQRCode": "WeChat QR コードで宣伝する",
    "Copy": "コピー",
    "BrowserNotSupportedCopyManually": "お使いのブラウザは直接コピーをサポートしていません。手動でコピーしてください",
    "GiftCardRecoveryTotal": "リサイクルされたギフトカードの総数",
    "TodaysGiftCardRecoveryCount": "本日のギフトカードのリサイクル数",
    "RegistrationDate": "登録日",
    "LastLogin": "最終ログイン",
    "Promotion Commission": "販売促進手数料",

    // userinfo 个人信息
    "Personal Info": "個人情報",
    "Nickname": "ニックネーム",
    "Birthdate": "生年月日",
    "Save": "保存",
    "CropImage": "写真をトリミングする",
    "UseImage": "写真を使用する",

    // goodsDetail 商品详情
    "Off": "割引",
    "Sold": "売られた",
    "Product": "製品",
    "Comment": "コメント",
    "Details": "詳細",
    "ReportViolation": "報告",
    "Cart": "ショッピングカート",
    "ChatMessages": "チャットメッセージ",
    "MyShop": "私の店",
    "MerchantLogin": "販売者のログイン",
    "Share": "共有",
    "ShareTo": "共有先",
    "WeChat": "微信",
    "Copy": "コピー",
    "Poster": "ポスター",
    "BrowserNotSupportedCopyManually": "お使いのブラウザは直接コピーをサポートしていません。手動でコピーしてください",
    "Follow": "焦点を当てる",
    "Unfollow": "フォローを解除する",
    "PleaseSelectQuantityAndCategory": "数量とカテゴリを選択してください。",
    "SelectedWithQuantity1": "{仕様}、数量 {数値} を選択しました。",
    "SelectedQuantity1": "選択した数量 {数値}。",
    "SelectedWithQuantity2": "{仕様}、数量 {数値} を選択しました。",
    "Add to cart": "カートに追加する",
    "Buy now": "即購入",
    "Stock": "在庫あり",
    "Pieces": "個",
    "Quantity": "量",
    "All": "全て",
    "Good": "良いレビュー",
    "Medium": "中立の評価",
    "Bad": "悪いレビュー",
    // 评论
    "Product review": "製品レビュー",
    "anonymous": "匿名",
    "noReviewInfo": "コメント情報は提供されていません",
    "Shop Owners Response": "店主が答える",
    "This product has no current reviews": "現在、この商品にはレビューがありません",
    "Product details": "製品詳細",
    "shop": "店",
    "customerService": "顧客サービス",
    "shoppingCart": "ショッピングカート",
    "addToCart": "カートに追加する",
    "buyNow": "即購入",
    "outOfStock": "選択された商品は現在在庫切れです、申し訳ございません。",
    "notAvailable": "選択した製品はもう入手できません。申し訳ありません。",
    "Store order message": "ストアオーダーニュース",
    "Confirm the order": "注文を確認する",
    "productAmount": "商品金額",
    "discount": "割引",
    "shippingFee": "貨物",
    "subtotal": "ストア小計",
    "Submit an order": "注文を送信する",
    // 退货
    "refundAdd": "返金を追加する",
    "back": "戻る",
    "refundDescription": "返金手順:",
    "proofOfRefund": "払い戻し伝票",
    "use": "使用",

    // 一元购
    "yi1": `1円購入`,
    "yi2": `価格ゾーン`,
    "yi3": `ゾーン`,
    "yi4": `購入履歴`,
    "yi5": `獲得した商品の記録`,
    "yi6": `引換コードを確認`,
    "yi7": `出金申請`,
    "yi8": `チャージする`,
    "yi9": `参加数量`,
    "yi10": `総数量`,
    "yi11": `不足数量`,
    "yi12": `今すぐ購入`,
    "yi13": `購入を続ける`,
    "yi14": `その他のゾーン`,
    "yi15": `さらに読み込む`,
    "yi16": `ご期待ください...`,
    "yi17": `ゾーン`,
    "yi18": `第`,
    "yi19": `回`,
    "yi20": `価格：`,
    "yi21": `さらに読み込む`,
    "yi22": `クイックペイメント - 購入する商品の情報`,
    "yi23": `購入数量`,
    "yi24": `（購入数量が多いほど商品を獲得する確率が高くなります！）`,
    "yi25": `合計: `,
    "yi26": `支払い成功`,
    "yi27": `支払い失敗`,
    "yi28": `理由：`,
    "yi29": `結果発表`,
    "yi30": `ラッキーナンバー`,
    "yi31": `商品獲得者`,
    "yi32": `おめでとうございます！この商品を獲得しました`,
    "yi33": `発表時間：`,
    "yi34": `購入時間：`,
    "yi35": `商品獲得者の合計購入数量: `,
    "yi36": ` 購入コード:`,
    "yi37": `受け取り`,
    "yi38": `現金で入金`,
    "yi39": `予約購入`,
    "yi40": `購入する`,
    "yi41": `獲得商品の記録`,
    "yi42": `当選日：`,

    "hunt1": `引換コード`,
    "hunt2": `運に恵まれる`,
    "hunt3": `止まらない勢い`,
    "hunt4": `引換コード`,
    "hunt5": `引換コード：`,
    "hunt6": `さらに読み込む`,
    "hunt7": `引き換えたい`,
    "hunt8": `引換コードを入力してください`,
    "hunt9": `引換価格は販売価格の10%割引です`,
    "hunt10": `商品リスト`,
    "hunt11": `ゾーン`,
    "hunt12": `言語`,
    "hunt13": `お知らせ`,
    "hunt14": `ナビゲーション`,
    "hunt15": `公式発表`,
    "hunt16": `トレジャーレコード`,
    "hunt17": `配送ルール`,
    "hunt18": `ルール説明`,
    "hunt19": `引き換えたい`,
    "hunt20": `お問い合わせ`,
    "hunt21": `メールアドレス`,
    "hunt22": `抽選ルール`,
    "hunt23": `ルール概要`,
    "hunt24": `1. 番号の割り当て：`,
    "hunt25": `0.1 USDT を支払うごとに、ユーザーはラッキーナンバーを 1 つ獲得します。番号は 000001 から順に配布され、目標参加者数（例：1000人）に達するまで続きます。`,
    "hunt26": `2. 抽選条件：`,
    "hunt27": `商品が目標参加者数（例：1000人）に達した場合、抽選プロセスに入ります。`,
    "hunt28": `3. 抽選時間：`,
    "hunt29": `最後の注文が確認された後、ブロックチェーンの時間が「05、10、15、25、30、35、40、45、50、55、00」のいずれかに該当する最も近い時間を待ちます。`,
    "hunt30": `4. 当選番号の計算：`,
    "hunt31": `1. ブロックハッシュ値から純粋な数字を取り出し、参加者総数で割った余りを計算：
                当選番号 =（ハッシュ値内の純粋な数字 % 参加者総数）+ 1`,
    "hunt32": `2. 計算結果に対応する番号が当選番号となります。`,
    "hunt33": `参加段階`,
    "hunt34": `ユーザーは 0.1 USDT を支払うごとにラッキーナンバーを 1 つ獲得します。`,
    "hunt35": `商品が目標参加者数に達すると、新規の参加は終了します。`,
    "hunt36": `抽選段階`,
    "hunt37": `最後の注文の正確な時間を記録します（例：15:47:23）。`,
    "hunt38": `ルールに従ったブロックチェーン時間を待ちます：`,
    "hunt39": `ブロックチェーンの時間が「05、10、15、25、30、35、40、45、50、55、00」のいずれかに該当する場合`,
    "hunt40": `条件に合致するブロックハッシュ値を取得します。`,
    "hunt41": `当選段階`,
    "hunt42": `ブロックハッシュ値から純粋な数字を抽出します。`,
    "hunt43": `例のブロックハッシュ値：0000000000000000000a16b6f44536e521000000adbcf3f4b2ec018ffabcd123`,
    "hunt44": `抽出した純粋な数字：16644536521000000342018123`,
    "hunt45": `参加者総数での割り算の余り：`,
    "hunt46": `当選番号`,
    "hunt47": `=（抽出した数字 % 参加者総数）+ 1`,
    "hunt48": `抽出した数字が 16644536521000000342018123 で、参加者総数が 1000 の場合：`,
    "hunt49": `=（16644536521000000342018123 % 1000）+ 1 = 123 + 1 = 124`,
    "hunt50": `結果の公表`,
    "hunt51": `プラットフォームは当選番号と該当するユーザー情報を発表します。`,
    "hunt52": `計算過程（注文時間、使用したブロックハッシュ、抽出した数字および当選番号の計算式）を完全に公開します。`,
    "hunt53": `利点`,
    "hunt54": `1. 公平性`,
    "hunt55": `公開されたブロックチェーンのハッシュ値を利用して、抽選結果が予測不可能かつ改ざん不可能であることを保証します。`,
    "hunt56": `2. 透明性`,
    "hunt57": `ユーザーはハッシュ値と番号割り当てプロセスを検証できます。`,
    "hunt58": `3. 高速`,
    "hunt59": `条件に合ったブロックが生成されるのを待つだけで、すばやく結果を得られます。`,
    "hunt60": `お知らせの詳細`,
    "hunt61": `購入数量：`,
    "hunt62": `件`,
    "hunt63": `購入コードを見る`,
    "hunt64": `購入コード：`,
    "hunt65": `ルール説明`,
    "hunt66": `注文について`,
    "hunt67": `迅速に商品をお届けするため、16:00 までのご注文は当日中に XX 配送または XX 配送で発送します。急ぎの場合は、追加料金を支払って XX 配送でお送りすることも可能です。他の配送サービスは現在サポートされていません。`,
    "hunt68": `請求書について`,
    "hunt69": `販売されたすべての商品には電子請求書を発行できます。注文を通じてカスタマーサポートに連絡し、請求書情報を提供してください。通常、1～3日以内に発行されます。祝日にあたる場合は、発行が遅れる可能性があります。`,
    "hunt70": `ラッキー購入`,


    "new1": "サンプル",
    "new2": "この商品は1000人の参加が必要です。最終注文時間は15:47:23です。\n抽選時間に合致する直近のブロック時刻は15:50:00です。",
    "new3": "ブロックハッシュ値は：",
    "new4": "ハッシュ値から純粋な数字のみを抽出：",
    "new5": "当選番号の計算：",
    "new6": "当選番号",
    "new7": "当選番号は124で、その番号に対応するユーザーが当選者となります。",
    "new8": `交換済み`,
    "new9": `未交換`,
    "new10": `残念ながら、当選しませんでした`,
    "new11": `おめでとうございます`,
    "new12": `今回の商品を獲得しました`,
    "new13": `交換する`,
    "new14": `ラッキーショッピング`,
    "new15": `商品を受け取り済み`,


    "new16": "商品を受け取りますか？",
    "new17": "交換しますか？",
    "copyS": "コピー成功",
    "copyE": "コピー失敗",
    "new18": "商品展示",
    "new19": "前ページ",
    "new20": "次ページ",
    "new21": "第",
    "new22": "ページ",
    "new23": "確認",
    "new24": "抽選待ち",

    "tool1": "ホーム",
    "tool2": "商品",
    "tool3": "お知らせ",
    "tool4": "ハントログ",
    "tool5": "配送",
    "tool6": "規則",
    "tool7": "交換",
    "tool8": "連絡",

    "new25": "商品引き換え",
    "new26": "gobuyユーザー名を入力してください",



    "ship1": "適用範囲",
    "ship2": "これらの配送ルールは、luckybuyのECプラットフォーム上のすべての注文に適用されます。プラットフォームはUSDTでの支払いのみを受け付けており、クレジットカードや現金での支払い、運賃控除には対応していません。以下のルールを制定します。",
    "ship3": "1. アメリカ国内の配送ルール",
    "ship4": "支払い方法",
    "ship5": "USDTでの支払いのみ受け付けています。クレジットカードや現金での支払いは対応していません。",
    "ship6": "代金引換サービス",
    "ship7": "代金引換サービスは米国内のお客様のみご利用いただけます。配送費の前払いは必要ありません。",
    "ship8": "配送ポリシー",
    "ship9": "注文金額には配送料は含まれず、別途お支払いが必要です。",
    "ship10": "配送範囲",
    "ship11": "アメリカ本土全域への配送に対応しています。",
    "ship12": "お客様へのご案内",
    "ship13": "注文後は、お客様の連絡先情報が正しいことを必ずご確認ください。受け取り時には、お客様または代理の方の署名が必要です。",
    "ship14": "2. アメリカ国外の配送ルール",
    "ship15": "USDTでの支払いのみ受け付けています。クレジットカードや現金での支払いは対応していません。",
    "ship16": "アメリカ国外のお客様は、注文の支払い完了後に追加の送料をお支払いいただく必要があります。",
    "ship17": "追加の送料支払いが完了次第、プラットフォームが出荷手配を行います。",
    "ship18": "代金引換ポリシー",
    "ship19": "代金引換サービスは提供していません。アメリカ国外のお客様は、注文処理前に配送料を完了する必要があります。",
    "ship20": "追加の送料手続き",
    "ship21": "注文後、プラットフォームが住所に基づいて送料を算出し、お客様にUSDTでの追加支払いを案内します。",
    "ship22": "送料の支払いが完了次第、プラットフォームが配送を手配し、物流追跡情報を提供します。",
    "ship23": "世界中のあらゆる国への配送に対応しています。具体的な配達時間は現地の物流状況により異なります。",
    "ship24": "住所と連絡先情報が正確であることをご確認ください。情報不備により配送できない場合は、お客様の責任となります。",
    "ship25": "目的地の税関に関する方針や規定はプラットフォームの責任範囲外です。お客様は税関手続きやその他の追加費用についてご自身でご確認・ご対応ください。",
    "ship26": "ご注意",
    "ship27": "1. 注文が支払い完了した後は、キャンセルや返金ができません。ご購入前に注文情報をご確認ください。",
    "ship28": "2. luckybuyは、輸送中の不可抗力（自然災害や政策の変更など）によって生じた問題に対して責任を負いませんが、お客様が問題解決できるよう最大限サポートいたします。",
    "ship29": "3. ご不明点などございましたら、当プラットフォームのカスタマーサービスまでお問い合わせください。",
    "ship30": "ご理解とご支援をいただき、ありがとうございます！",
    "ship31": "luckybuyはお客様のために誠心誠意サービスいたします。",

    // 礼品卡相关
    'Original Price':'元の価格',
    'Actual Payment':'実際の支払い',
    'Balance':'残高',
    'MessageBox.buy.card': 'このギフトカードを購入してもよろしいですか？',
    'MyCard':'マイカード',
    'Please upload pictures':'画像をアップロードしてください',
    'Share audit list':'監査リストを共有',
    'Share page':'ページを共有',
    'Audit result':'監査結果',
    'Share to the community':'コミュニティに共有',
    'imshares1':'ステップ紹介',
    'imshares2':'ステップ 1：ソーシャルメディアで製品を共有してください。',
    'imshares3':'ステップ 2：製品が共有されたページのスクリーンショットを撮影し、GoBuyにアップロードしてください。',
    'Share Time':'共有時間',
    'Audit status':'監査状況',
    'Reason for failure':'失敗の理由',
    'Pending approval':'承認待ち',
    'Approved':'承認済み',
    'Audit failed':'監査失敗',
    'Url Copied': 'リンクが正常にコピーされました。共有にリダイレクトしています...',
    "Points Logs": "ポイント履歴",
    "My Points": "私のポイント",
    "Go Excharge": "交換に行く",
    "Confirm points excharge": "すべてのポイントを残高に変換してもよろしいですか？",
    'is not share': 'あなたはまだ共有タスクを完了していません',
    'is buied': 'あなたは今日すでに購入しています',
    'My card': '私のカード',
    "Country/Region": "国/地域",
    "Contact info": "連絡先情報",
    "Please enter real name": "本名を入力してください",
    "Please enter Phone Number": "電話番号を入力してください",
    "Please enter State/Province/Region": "州/県/地域を入力してください",
    "Please enter City": "市区町村を入力してください",
    "Please enter Street Address": "住所を入力してください",
    "Please enter Postal Code": "郵便番号を入力してください",
    "lucky_draw_winning_products": "抽選で当たった製品",
    "refundAdd": "返金リクエスト",
    "refundDescription": "返金の説明",
    "productQualityIssue": "製品の品質問題",
    "logisticsTransportIssue": "物流・輸送問題",
    "sellerPlatformIssue": "販売者またはプラットフォームの問題",
    "personalReason": "個人的な理由",
    "otherSpecialCases": "その他の特別なケース",
    "hunt points rule": "ポイント説明",
    "hunt points rule1": "1. ポイント獲得: ユーザーはラッキーな購入に参加し、投資額0.1ドルごとに1ポイントを獲得できます。",
    "hunt points rule2": "2、ポイント交換：1ポイント = 0.01%ドル",
    'Login Password': "ログインパスワード",
    "Level": "レベル",

    "guide.Rewards": "報酬の紹介",
    "guide.title": "初心者ガイド",
    "guide.Invitation.Reward": "イベント報酬",
    "guide.Order.Sharing": "購入シェア",
    "guide.section1.title": "ラッキーバイ購入ガイド",
    "guide.section1.step1": "購入を選択：USDセクションに入り、お気に入りの商品を選びます。",
    "guide.section1.step2": "数量を選択：参加したい購入数を入力します。",
    "guide.section1.step3": "購入数：1口わずか0.1ドルで購入可能。",
    "guide.section1.step4": "抽選を待つ：システムが自動でラッキー当選者を選びます。",
    "guide.section2.title": "ブラインドボックス購入ガイド",
    "guide.section2.step1": "ブラインドボックスを開く：ブラインドボックスセクションをクリックします。",
    "guide.section2.step2": "すぐに参加：10ドルを支払います。",
    "guide.section2.step3": "賞品を発表：最高300万ドルの賞品を獲得できます。",
    "guide.section3.title": "ギフトカード購入ガイド",
    "guide.section3.step1": "コミュニティで共有：すぐにキャンペーンを共有し、情報をアップロードします。",
    "guide.section3.step2": "額面を選択：自由にギフトカードの価格を選択できます。",
    "guide.section3.step3": "100枚のギフトカードをわずか98ドルで購入可能。",
    "guide.section3.step4": "即時買取：100％買取で2ドル獲得",
    "guide.tip.title": "ご注意：お得な特典をお見逃しなく",
    "guide.tip.luckyBuy": "わずか0.1ドルで参加可能、1ドルから50,000ドルの賞品を獲得するチャンス！",
    "guide.tip.luckyBuy1": "チームコミッション報酬：友達を招待して購入すると最大0.2%の報酬が得られます！",
    "guide.tip.luckyBuy2": "ポイント交換：ラッキーバイ1回の購入ごとに1ポイント獲得、1000ポイントで0.1ドル！",
    "guide.tip.example": "例：",
    "guide.tip.example1": "ユーザーAを招待し、Aが1000ドル購入 → あなたは2ドルの報酬を獲得。",
    "guide.tip.example11": "AがユーザーBを招待し、Bが1000ドル購入 → さらに1ドルの報酬を獲得。",
    "guide.tip.boxTitle": "ブラインドボックス抽選",
    "guide.tip.box": "10ドルで1回参加、賞品価値は最大300万ドル！",
    "guide.tip.cardTitle": "ギフトカード",
    "guide.tip.card": "チームコミッション：友達を招待して購入すると最大0.4%の報酬が得られます！",
    "guide.tip.example2": "ユーザーAに100ドルのギフトカードを購入させると、0.4ドルの報酬を獲得できます。",
    "guide.tip.example3": "AがユーザーBを招待し、Bが100ドルのギフトカードを購入すると、さらに0.2ドルの報酬が得られます。",
    "guide.tip.callToAction": "今すぐ参加して、あなたのラッキージャーニーを始めましょう！",
    "guide.warning.title": "ご注意",
    "guide.warning.rule1": "どのような場合にコミッションが無効になりますか？",
    "guide.warning.answer1": "ソフトウェアや他のプラットフォームを使った不正なコミッション取得は発覚次第、すべての報酬が没収されアカウントが停止されます。",
    "guide.warning.rule2": "自分自身を招待してもコミッションはもらえますか？",
    "guide.warning.answer2": "いいえ。手動でチェックし、不正が確認された場合はすべての報酬が没収され、招待コミッションの資格が取り消されアカウントは削除されます。",
    "invite.title": "特典到来｜友達を招待して4つの大きな賞品をゲット！",
    "invite.reward1.title": "報酬1：グループに招待して、簡単にドル＋ギフトカードを獲得",
    "invite.reward1.item1": "10人の新規メンバーをグループに招待するごとに、レッドパケット報酬を獲得！",
    "invite.reward1.item2": "さらに1ドルのギフトカードをプレゼント",
    "invite.reward1.item3": "多く招待すればするほど報酬もアップ！レッドパケットは即時配布、ギフトカードは即時交換可能！",
    "invite.reward2.title": "報酬2：ラッキーバイ、何もしなくてもコミッションを獲得",
    "invite.reward2.item1": "友達がラッキーバイに参加するたびに、あなたもコミッションを受け取れます！",
    "invite.reward2.item2": "コミッションに上限なし、買えば買うほどあなたの収入も増加！",
    "invite.reward3.title": "報酬3：ギフトカード",
    "invite.reward3.item1": "友達がギフトカードを購入すると、即座にコミッションをゲット！",
    "invite.reward3.item2": "ゼロコストのシェアリンク、自動追跡、超簡単操作：",
    "invite.reward3.item3": "リンクを送る → 友達が注文 → 支払いを待つ！",
    "invite.callToAction": "今すぐ友達をグループに招待して、全ての特典を手に入れよう！一緒に遊びながら稼ごう！",
    "share.title": "GoBuyの当選体験をシェアして1ドルのギフトカードをゲット",
    "share.subtitle": "シェアタイトル",
    "share.content1": "GoBuyラッキーショッピングに感謝！メンバーの一人が小額投資で賞品を獲得し、無事に出金しました！✨",
    "share.content2": "あなたの番です！当選体験をシェアするだけで、無料の1ドルGoBuyギフトカードをもらえます！見逃さないで—簡単で報酬豊富、楽しい！",
    "share.inviteLink": "あなたの招待コードを添付：",
    "share.stepsTitle": "参加方法：",
    "share.step1": "ラッキーバイエリアで購入/注文コードのスクリーンショットをアップロード",
    "share.step2": "「おめでとうございます！当選しました！」メッセージのスクリーンショットをアップロード",
    "share.step3": "出金申請と取引成功のスクリーンショットをアップロード",
    "share.step4": "上記の手順を完了後、SNSでのシェアスクリーンショットをカスタマーサポートに送信して確認を受ける",
    "share.email": "カスタマーサポートメール：",
    "share.footer": "幸運をあなたに—遊び続けて、勝ち続けよう！GoBuy—毎日の買い物を楽しくお得に！",
    "doubleBet.title": "ベッティング・ミラクル｜シンプルな3ステップで、逆転して大きな賞品を獲得！",
    "doubleBet.step1": "第1ラウンド：1ドルゾーンを選び、0.5ドルを購入し、5ユニットを購入して、当たったら止めます。",
    "doubleBet.step2": "当たらなかった場合、第2ラウンド：3ドルゾーンを選び、1.5ドルを購入し、15ユニットを購入して、当たったら止めます。",
    "doubleBet.step3": "それでも当たらなかった場合、第3ラウンド：8ドルゾーンを選び、4ドルを購入し、40ユニットを購入して、当たりおめでとう！",
    "doubleBet.step4": "当たった後、前のラウンドの損失をカバーし、利益を得て、再び第1ラウンドから始めます。",
    "invite.reward4.title": "報酬4：期間限定の特典 | 新規ユーザー専用のギフト",
    "invite.reward4.step1": "1回のラッキー購入に無料で参加",
    "invite.reward4.step2": "1回のミステリーボックスロトを無料で有効化",
    "invite.reward4.step3": "指定されたタスクを完了して、追加で$1の現金報酬を獲得",
    "reward.register.title": "登録報酬",
    "reward.register.point1": "新規ユーザーは登録するとLucky Buyへの無料参加が1回もらえます。",
    "reward.register.point2": "登録後にグループに参加して、紅包イベントに参加できます。",
    "reward.task.title": "タスク報酬",
    "reward.task.point1": "ゲストとしてログインし、ブラインドボックスを1回開けてください。",
    "reward.task.point2": "次の3つのLucky Buyタスクを各ゾーンで1回ずつ完了してください：",
    "reward.task.subtask1": "1ドルゾーン：0.5ドルを1回購入",
    "reward.task.subtask2": "3ドルゾーン：1.5ドルを1回購入",
    "reward.task.subtask3": "8ドルゾーン：4ドルを1回購入",
    "reward.task.point3": "上記2つのタスクを完了すると、1ドルの報酬を獲得！",
    "reward.share.title": "共有報酬",
    "reward.share.desc": "GoBuyでサプライズボックスとラッキードローに当選しました！",
    "reward.share.desc3": "登録後すぐに当たったよ！すごい！",
    "reward.share.desc4": "✨当選スクリーンショットをシェアすると、1ドルの報酬がもらえます。",
    "reward.share.desc1": "友達10人を招待して登録完了すると、1ドルを獲得。1000人招待で100ドルの報酬も！上限なし、招待すればするほど報酬が増えます！",
    "reward.invite.title": "招待報酬",
    "reward.invite.desc": "友達10人を招待し、登録を完了させてください。",
    "reward.share.desc2": "上記のタスクを完了すると、共有と招待の報酬がもらえます！",
    "reward.invite.desc1": "上記のタスクを完了すると、招待イベントの報酬がもらえます！",
}
export default Jap
